import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '@boxx/shared-components';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { PipesModule } from 'src/pipes/pipes.module';
import { ConversationItemOpenComponent } from './conversation-item-open/conversation-item-open.component';
import { ConversationItemComponent } from './conversation-item/conversation-item.component';
import { GbmItemOpenComponent } from './gbm-item-open/gbm-item-open.component';
import { LeadItemOpenComponent } from './lead-item-open/lead-item-open.component';
import { ReviewItemOpenComponent } from './review-item-open/review-item-open.component';

@NgModule({
  declarations: [
    ConversationItemComponent,
    ConversationItemOpenComponent,
    GbmItemOpenComponent,
    LeadItemOpenComponent,
    ReviewItemOpenComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    SharedComponentsModule,
    PipesModule,
    NgxPermissionsModule.forChild(),
  ],
  exports: [
    ConversationItemComponent,
    ConversationItemOpenComponent,
    GbmItemOpenComponent,
    LeadItemOpenComponent,
    ReviewItemOpenComponent
  ],
})
export class MessagesCoreComponentsModule {}
